import WacomSignatureManager from './../../assets/js/signature/WacomSignatureManager';
import './index.css';
export default {
  name: 'WacomSignature',
  props: {
    value: {
      type: String,
      default: ''
    },
    imgWidth: {
      type: Number,
      default: 200
    },
    imgHeight: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      signature: null,
      sigVal: '',
      canSignature: false
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$props.value !== this.sigVal) this.sigVal = this.$props.value;
      this.$on('capture', this.capture);
      this.init()
    });
  },
  watch: {
    '$props.value'(val) {
      if (val !== this.sigVal) this.sigVal = val;
    },
    'sigVal'(val) {
      if (this.$props.value !== val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },
  computed: {},
  methods: {
    init() {
      return new Promise((resolve, reject) => {
        try {
            this.signature = null;
            this.signature = new WacomSignatureManager({width: this.$props.imgWidth, height: this.$props.imgHeight});
            this.signature.OnLoad((e) => {
              if (this.$props.imgWidth)  this.$refs.img.style.width  = this.$props.imgWidth  + 'px';
              if (this.$props.imgHeight) this.$refs.img.style.height = this.$props.imgHeight + 'px';
              this.canSignature = true;
              resolve(true)
            }, () => {
              this.$emit('capture-cancel')
              resolve(false)
            });
        } catch (e) {
          this.canSignature = false;
          reject(false)
        }
      })
    },
    capture() {
      this.init().then(() => {
        this.signature.Capture(this.onCapture);
      }, () => {
        alert('Ошибка проверки подключения планшета подписи. Пожалуйста перезагрузите страницу и подпишите повторно.');
      })
    },
    onCapture(sig) {
      this.sigVal = sig;
      this.$emit('capture-complete', sig);
    }
  }
}